import { ReactNode } from 'react';

import { InfoOutlined } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import Subscription from 'icons/subscription.svg';
import { FormattedMessage, useIntl } from 'react-intl';

import { SubscriptionStatusProps } from '../types';

import * as S from '../styles';

const SubscriptionStatus = ({
  statusSchema,
  expiredAt,
}: SubscriptionStatusProps) => {
  const intl = useIntl();

  return (
    <S.StatusContainer>
      <Typography variant="h4">
        <Subscription />
      </Typography>
      <S.StatusContent>
        <S.StatusText isMultiline={statusSchema.isMultiline}>
          <FormattedMessage
            id={statusSchema.label}
            values={{
              b: (chunks: ReactNode) => (
                <S.SubscriptionStatusColor color={statusSchema.statusColor}>
                  {chunks}
                </S.SubscriptionStatusColor>
              ),
            }}
          />
        </S.StatusText>
        <S.TooltipText>
          <Tooltip
            title={intl.formatMessage(
              { id: statusSchema.tooltipText },
              { date: new Date(expiredAt || '') },
            )}
            arrow
            placement="top"
          >
            <InfoOutlined />
          </Tooltip>
        </S.TooltipText>
      </S.StatusContent>
    </S.StatusContainer>
  );
};

export default SubscriptionStatus;
